export async function openAttachment(appealId, attachmentId, token) {
  const url = `/api/v1/appeals/attachments/${appealId}/${attachmentId}`;
  const headers = {};
  if (token) headers['Authorization'] = `Bearer ${token}`;

  const resp = await fetch(url, {
    method: 'GET',
    headers,
    credentials: 'include'
  });

  if (!resp.ok) {
    const text = await resp.text().catch(() => null);
    throw new Error(`Failed to fetch attachment (${resp.status}): ${text || resp.statusText}`);
  }

  const blob = await resp.blob();
  const disposition = resp.headers.get('content-disposition') || '';
  let filename = 'attachment';
  const m = /filename="?([^";]+)"?/.exec(disposition);
  if (m && m[1]) filename = decodeURIComponent(m[1]);

  const blobUrl = URL.createObjectURL(blob);

  // Open a new blank window and write an iframe so the blob is displayed inline
  const newWin = window.open();
  if (!newWin) throw new Error('Popup blocked');

  const html = `<!doctype html><html><head><title>${filename}</title></head><body style="margin:0"><iframe src="${blobUrl}" style="border:0;width:100%;height:100vh"></iframe></body></html>`;
  newWin.document.write(html);
  // Revoke object URL when window is unloaded
  newWin.addEventListener('unload', () => URL.revokeObjectURL(blobUrl));
}

export default openAttachment;
